/**
 * Input group component
 *
 * Optional props:
 * grow : string - applies flex-grow
 * shrink : string - applies flex-shrink
 * basis : string - applies flex-basis
 *
 * Examples of component:
 * <Column basis="200px">Input and so on</Column>
 * <Column grow="3">Input and so on</Column>
 *
 */

import styled from 'styled-components';

const Column = styled.div`
	padding-left: 10px;
	padding-right: 10px;
	flex-grow: ${props => props.grow || '1'};
	flex-shrink: ${props => props.shrink || '0'};
	flex-basis: ${props => props.basis || '0'};
	max-width: 100%;
	flex-direction: column;

	${props =>
		props.justify &&
		`
		display: flex;
		justify-content: ${props.justify};
	`};
	${props =>
		props.align &&
		`
		display: flex;
		align-items: ${props.align};
	`};
`;

export default Column;



// WEBPACK FOOTER //
// ./src/components/Common/Column/Column.js